<div>
    <p class="text-tooltip" #tooltip="matTooltip" [matTooltip]="getTooltip()" [matTooltipPosition]="'above'" matTooltipHideDelay="500">{{ getTextBuffer() }}</p>
</div>